import { Injectable, signal } from '@angular/core';

export interface Crumb {
  label: string;
  link?: string;
}

/** Pages set their trail once their data loads; the header renders it. */
@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  readonly crumbs = signal<Crumb[]>([]);

  set(crumbs: Crumb[]): void {
    this.crumbs.set(crumbs);
  }
}
